document.addEventListener('DOMContentLoaded', function () {
  
  const atcButton = document.getElementById('add-to-cart-button');
  const inputPincode = document.getElementById('pincode-input');
  const checkPincodeButton = document.getElementById('pincode-submit');
  const message = document.getElementById('pincode-message');

  // Disable Add to Cart button initially
  atcButton.style.backgroundColor = '#cc1539';

  // Function to set a cookie
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + "; path=/" + expires;
  }

  // Function to get a cookie
  function getCookie(name) {
    let nameEQ = name + "=";
    let cookiesArray = document.cookie.split(';');
    for (let i = 0; i < cookiesArray.length; i++) {
      let cookie = cookiesArray[i].trim();
      if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length);
    }
    return null;
  }

  // Auto-fill pincode from cookie if available
  const savedPincode = getCookie("user_pincode");
  if (savedPincode) {
    inputPincode.value = savedPincode;
  }

  // Handle pincode checking
  checkPincodeButton.addEventListener('click', function () {
    const pincodeValue = inputPincode.value.trim();
    message.innerText = '';

    if (!pincodeValue) {
      message.innerText = 'Please enter a pincode.';
      message.style.color = 'red';
      atcButton.disabled = true;
      return;
    }

    // Google Sheets CSV URL (replace with your unique URL)
    const sheetUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQ_Xja1pstjOAmh6Cp9jQ3UTkZKVnvG94EHwBpV6ZFXvOxRG4wYaYbU1uayejM0U7A7HWniAMxXcNot/pub?output=csv';

    fetch(sheetUrl)
      .then(response => response.text())
      .then(data => {
        const pincodes = data.split('\n').map(row => row.trim());

        if (pincodeValue.length !== 6) {
          message.innerText = 'Please enter a valid 6-digit pincode.';
          message.style.color = 'red';
          atcButton.disabled = true;
        } else if (pincodes.includes(pincodeValue)) {
          message.innerText = 'Delivery is available in your area';
          message.style.color = 'green';
          atcButton.disabled = false;
          
          // Save pincode in cookie for 30 days
          setCookie("user_pincode", pincodeValue, 30);
        } else {
          message.innerText = "Sorry, we currently don't deliver to your area.";
          message.style.color = 'red';
          
          atcButton.disabled = true;
        }
        document.querySelector('.pincode-error').style.display = "none";
      })
      .catch(error => {
        console.error('Error fetching pincode data:', error);
        message.innerText = 'Error checking pincode. Please try again later.';
        message.style.color = 'red';
        atcButton.disabled = true;
      });
  });

  // Prevent Add to Cart button submission if no pincode is entered
  atcButton.addEventListener('click', function (event) {
    if (atcButton.disabled) {
      message.innerText = 'PIN code is required before adding to cart.';
      message.style.color = 'red';
      event.preventDefault();
    }
  });
});
